<template>
    <div class="page my-page">
        <div style="position: relative"><img src="@assets/images/billboard-head-logo.png" class="head-img"/>
            <div class="league-more" @click="$router.push('/LeagueBoard')">更多 ></div>
            <img src="@assets/images/board-header-people2.png" class="board-header-img">
        </div>
        <div class="integra-box">
            <div class="board-box">
                <el-row class="board-row">
                    <el-col :span="6"><img src="@assets/images/billboard-ms.png" class="board-img"/>
                    </el-col>
                    <el-col :span="6">
                        <img :src="'/static/billboard/'+billboardData.msBillboard[0].leagueId+'.png'"
                             class="league-ranking-img"/>
                        <br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.msBillboard[0].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.msBillboard[0].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.msBillboard[1].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.msBillboard[1].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.msBillboard[1].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.msBillboard[2].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.msBillboard[2].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.msBillboard[2].percent }}%</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="integra-box">
            <div class="board-box">
                <el-row class="board-row">
                    <el-col :span="6"><img src="@assets/images/billboard-bk.png" class="board-img"/>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.bkBillboard[0].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.bkBillboard[0].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.bkBillboard[0].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.bkBillboard[1].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.bkBillboard[1].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.bkBillboard[1].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.bkBillboard[2].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.bkBillboard[2].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.bkBillboard[2].percent }}%</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="integra-box">
            <div class="board-box">
                <el-row class="board-row">
                    <el-col :span="6"><img src="@assets/images/billboard-gz.png" class="board-img"/>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.gzBillboard[0].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.gzBillboard[0].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.gzBillboard[0].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.gzBillboard[1].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.gzBillboard[1].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.gzBillboard[1].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.gzBillboard[2].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.gzBillboard[2].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.gzBillboard[2].percent }}%</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="integra-box">
            <div class="board-box">
                <el-row class="board-row">
                    <el-col :span="6"><img src="@assets/images/billboard-qy.png" class="board-img"/>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qyBillboard[0].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qyBillboard[0].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qyBillboard[0].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qyBillboard[1].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qyBillboard[1].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qyBillboard[1].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qyBillboard[2].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qyBillboard[2].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qyBillboard[2].percent }}%</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="integra-box">
            <div class="board-box">
                <el-row class="board-row">
                    <el-col :span="6"><img src="@assets/images/billboard-qx.png" class="board-img"/>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qxBillboard[0].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qxBillboard[0].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qxBillboard[0].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qxBillboard[1].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qxBillboard[1].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qxBillboard[1].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qxBillboard[2].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qxBillboard[2].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qxBillboard[2].percent }}%</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="integra-box">
            <div class="board-box">
                <el-row class="board-row">
                    <el-col :span="6"><img src="@assets/images/billboard-qt.png" class="board-img"/>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qtBillboard[0].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qtBillboard[0].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qtBillboard[0].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qtBillboard[1].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qtBillboard[1].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qtBillboard[1].percent }}%</span>
                        </div>
                    </el-col>
                    <el-col :span="6"><img :src="'/static/billboard/'+billboardData.qtBillboard[2].leagueId+'.png'"
                                           class="league-ranking-img"/><br>
                        <div class="league-ranking-name-box"><span
                                class="league-ranking-name-text">{{ billboardData.qtBillboard[2].leagueName| ellipsis(6) }}</span><br>
                            <span class="league-ranking-rate-text">{{ billboardData.qtBillboard[2].percent }}%</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="billboard-person">
            <el-row class="user-ranking-row">
                <el-col :span="8">
                    <div class="user-ranking-img-box2"><img class="user-ranking-img-2" :src="userRankingData[1].avatar"/><br>
                    </div>
                    <div class="user-ranking-name-box"><span class="user-ranking-name">{{
              userRankingData[1].nickname| ellipsis(6)
            }}<br><span class="user-ranking-integra">{{ userRankingData[1].integral }}</span></span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="user-ranking-img-box1"><img class="user-ranking-img-1" :src="userRankingData[0].avatar"/><br>
                    </div>
                    <div class="user-ranking-name-box"><span class="user-ranking-name">{{
              userRankingData[0].nickname| ellipsis(6)
            }}<br><span class="user-ranking-integra">{{ userRankingData[0].integral }}</span></span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="user-ranking-img-box3"><img class="user-ranking-img-2" :src="userRankingData[2].avatar"/><br>
                    </div>
                    <div class="user-ranking-name-box"><span class="user-ranking-name">{{
              userRankingData[2].nickname| ellipsis(6)
            }}<br><span class="user-ranking-integra">{{ userRankingData[2].integral }}</span></span>
                    </div>
                </el-col>
            </el-row>
            <div class="person-more" @click="$router.push('/PersonBoard')">更多 ></div>
        </div>
        <div class="last-index-img"></div>
    </div>
</template>

<script>
    import "@assets/css/swiper.min.css";
    import {userRanking, qryBillboard} from "@api/lesson";

    export default {
        name: "Billboard",
        components: {},
        props: {},
        data: function () {
            return {
                billboardData: {},
                userRankingData: []
            };
        },
        created() {
        },
        mounted: function () {
            this.initBillboard();
            this.initRanking();
        },
        filters: {
            ellipsis(value, limit) {
                if (!value) return "";
                if (value.length > limit) {
                    return value.slice(0, limit) + "...";
                }
                return value;
            },
        },
        methods: {
            initBillboard() {
                let loading = this.$weui.loading("数据加载中");
                let that = this;
                qryBillboard().then(res => {
                    that.billboardData = res;
                });
                loading.hide();
            },
            initRanking() {
                let loading = this.$weui.loading("数据加载中");
                let that = this;
                userRanking().then(res => {
                    that.userRankingData = res;
                });
                loading.hide();
            }
        }
    };
</script>
<style scoped>
    [v-cloak] {
        display: none;
    }

    .index .follow {
        z-index: 100000;
    }

    .last-index-img {
        height: 35vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../../assets/images/classChannel/4.jpg");
    }

    .my-page {
        width: 100%;
    }

    .head-img {
        margin-left: 5vw;
        margin-top: 2vh;
        width: 45vw;
    }

    .integra-box {
        border: 1px solid #ebebeb;
        border-radius: 3px;
        transition: 0.2s;
        background-color: #fafafa;
        width: 95vw;
        margin-left: 2.5vw;
        margin-top: 1vh;
    }

    .billboard-person {
        position: relative;
        text-align: center;
        /*width: 100%;*/
        margin-top: 1vh;
        margin-left: 2vw;
        margin-right: 2vw;
        height: 35vh;
        background-size: 100% 100%; /*按比例缩放*/
        /*height: 100%;*/
        background-image: url("../../assets/images/billboard-person.png");
        /*background-size: contain;*/
        background-repeat: no-repeat;
        background-color: #66c5f5;
    }

    .board-row {
        display: inline;
        max-height: 20vh;
    }

    .board-img {
        width: 100%;
        margin: -1vh;
        overflow-y: hidden;
        object-fit: cover;
    }

    .user-ranking-row {
        margin-left: 15vw;
        width: 70vw;
        height: 80vh;
        font-size: smaller;
    }

    .user-ranking-img-1 {
        margin-top: 3.6vh;
        width: 65%;
        border-radius: 50%;
        overflow: hidden;
    }

    .user-ranking-img-2 {
        margin-top: 3.7vh;
        width: 65%;
        border-radius: 50%;
        overflow: hidden;
    }

    .user-ranking-name {
        font-size: small;
        color: #fafafa;
        font-weight: bolder;
        width: 100%;
    }

    .user-ranking-name-box {
        text-align: center;
        width: 90%;
        background-color: #66c5f5;
    }

    .user-ranking-img-box2 {
        width: 10vh;
        height: 11vh;
        margin-top:12vh;
        background-image: url("../../assets/images/geren2-1.png");
        background-size: 100% 100%; /*按比例缩放*/
        background-repeat: no-repeat;
        text-align: center;
    }
    .user-ranking-img-box1 {
        width: 10vh;
        height: 11vh;
        margin-top:10vh;
        background-image: url("../../assets/images/geren1-1.png");
        background-size: 100% 100%; /*按比例缩放*/
        background-repeat: no-repeat;
        text-align: center;
    }
    .user-ranking-img-box3 {
        width: 10vh;
        height: 11vh;
        margin-top:13vh;
        background-image: url("../../assets/images/geren3-1.png");
        background-size: 100% 100%; /*按比例缩放*/
        background-repeat: no-repeat;
        text-align: center;
    }
    .user-ranking-integra {
        font-size: small;
        color: #e5e5e5;
        font-weight: lighter;
    }

    .board-box {
        width: 100%;
        display: inline;
    }

    .league-ranking-img {
        width: 70%;
        margin-top: 10%;
    }

    .league-ranking-name-box {
        width: 100%;
        text-align: center;
    }

    .league-ranking-name-text {
        font-weight: normal;
        font-size: smaller;
    }

    .league-ranking-rate-box {
        width: 100%;
        text-align: center;
    }

    .league-ranking-rate-text {
        font-weight: lighter;
        font-size: small;
        color: #ee5a52;
    }

    .el-col {
        text-align: center;
        overflow-y: hidden;
    }

    .person-more {
        text-align: right;
        position: absolute;
        right: 3vw;
        top: 3vh;
        font-weight: bolder;
        color: #0c61e0;
        font-size: smaller;
    }

    .league-more {
        position: absolute;
        right: 3vw;
        bottom: 1vh;
        font-weight: bolder;
        color: #f6f6f6;
        font-size: smaller;
    }

    .board-header-img {
        position: absolute;
        right: 20vw;
        top: 5vh;
        width: 15vw;
    }
</style>
